// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TAPr7vWBulJEjv3617Fs {
    width: 100%;
    padding: 1rem;
    border-radius: 8px;
    display: flex;
    gap: 1rem;
    font-size: 1rem;
    word-break: break-word;
    box-sizing: border-box;
    text-align: left;
    align-items: flex-start;

    &.tR0fSMyLsCpzrmaTCnCK {
        background-color: var(--color-feedback-info);
        border: 1px solid var(--color-feedback-info-border);
    }

    &.QRU1xLFtrELJBM2IZMI2 {
        background-color: var(--color-feedback-error);
        border: 1px solid var(--color-feedback-error-border);
    }

    button {
        width: auto;
        font-size: 1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/InlineNotification/InlineNotification.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;;IAEvB;QACI,4CAA4C;QAC5C,mDAAmD;IACvD;;IAEA;QACI,6CAA6C;QAC7C,oDAAoD;IACxD;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;AACJ","sourcesContent":[".container {\n    width: 100%;\n    padding: 1rem;\n    border-radius: 8px;\n    display: flex;\n    gap: 1rem;\n    font-size: 1rem;\n    word-break: break-word;\n    box-sizing: border-box;\n    text-align: left;\n    align-items: flex-start;\n\n    &.info {\n        background-color: var(--color-feedback-info);\n        border: 1px solid var(--color-feedback-info-border);\n    }\n\n    &.error {\n        background-color: var(--color-feedback-error);\n        border: 1px solid var(--color-feedback-error-border);\n    }\n\n    :global(button) {\n        width: auto;\n        font-size: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TAPr7vWBulJEjv3617Fs`,
	"info": `tR0fSMyLsCpzrmaTCnCK`,
	"error": `QRU1xLFtrELJBM2IZMI2`
};
module.exports = ___CSS_LOADER_EXPORT___;
